
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      skeleton: {
        backgroundColor: '#f4f4f4',
        borderRadius: '5px'
      },
      skeletondiv: {
        height: '100%',
        width: '100%'
      }
    }
  }
}
